import type { JSX, ReactNode } from 'react';
import { ProtectedRoute } from 'src/features/auth';
import { LazyRoute } from './components';
import { useActiveDepartmentStoreUpdate } from './hooks';

const LoadingWard = ({ children }: { children: ReactNode }): JSX.Element => {
    useActiveDepartmentStoreUpdate();

    return (
        <ProtectedRoute>
            <LazyRoute>{children}</LazyRoute>
        </ProtectedRoute>
    );
};

export default LoadingWard;
